import condeNast from './condeNast';
import horizontalRule from './horizontalRule';
import PTAudioFile from './PTaudioFile';
import PTAudioPlaylist from './audioPlaylist';
import PTGoogleMapsEmbed from './googleMapsEmbed';
import PTImage, { PreventUpscalePTImage } from './image';
import PowerBIEmbed from './powerBIEmbed';
import PTYoutubePlayer from './youtube';
import SponsorLogoRow from './sponsorLogoRow';
import ProductTable from './productTable';
import { PTApplePodcastEmbed } from './applePodcastEmbed';
import { PTSpotifyPlaylistEmbed } from './spotifyPlaylistEmbed';
import Footnote from './footnote';

const types = {
	applePodcastEmbed: PTApplePodcastEmbed,
	audioFileEmbed: PTAudioFile,
	audioPlaylistEmbed: PTAudioPlaylist,
	condeNast: condeNast,
	googleMapsEmbed: PTGoogleMapsEmbed,
	horizontalRule: horizontalRule,
	image: PTImage,
	powerBIEmbed: PowerBIEmbed,
	productTable: ProductTable,
	sponsorLogoRow: SponsorLogoRow,
	spotifyPlaylist: PTSpotifyPlaylistEmbed,
	youtube: PTYoutubePlayer,
};

export default types;
export { Footnote, PreventUpscalePTImage };
